
import { defineComponent } from 'vue'
import { ReportChartType } from '@/model/models'

// Bubble deliberately not offered here: ReportBubbleChart hardcodes column positions, which
// doesn't fit dynamically-shaped AI query results.
export default defineComponent({
  name: 'AiReportChartTypeSelect',
  emits: ['change'],
  data() {
    return {
      ReportChartType,
      selected: ReportChartType.Bar as string
    }
  },
  created() {
    this.$emit('change', this.selected)
  },
  methods: {
    onChange() {
      this.$emit('change', this.selected)
    }
  }
})
